"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SitewidePromoBar", {
  enumerable: true,
  get: function get() {
    return _SitewidePromoBar.SitewidePromoBar;
  }
});
require("./css/main.css");
var _SitewidePromoBar = require("./components/SitewidePromoBar");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJyZXF1aXJlIiwiX1NpdGV3aWRlUHJvbW9CYXIiXSwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFwiLi9jc3MvbWFpbi5zY3NzXCJcbmltcG9ydCB7IFNpdGV3aWRlUHJvbW9CYXIgfSBmcm9tIFwiLi9jb21wb25lbnRzL1NpdGV3aWRlUHJvbW9CYXJcIlxuXG5leHBvcnQgeyBTaXRld2lkZVByb21vQmFyIH1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQUEsT0FBQTtBQUNBLElBQUFDLGlCQUFBLEdBQUFELE9BQUEifQ==